import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import PostCreateForm from '@/features/social/components/post-create/PostCreateForm'
import { SocialPost } from '@/features/social/types'

interface PostCreateDialogProps {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  onClose: () => void
  initialData?: Partial<SocialPost>
  onSuccess?: () => void
}

export default function PostCreateDialog({
  open,
  onOpenChange,
  onClose,
  initialData,
  onSuccess
}: PostCreateDialogProps) {
  // If controlled via open/onOpenChange
  if (open !== undefined && onOpenChange) {
    return (
      <Dialog open={open} onOpenChange={onOpenChange}>
        <DialogContent className="max-w-4xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>{initialData ? 'Edit Post' : 'Create New Post'}</DialogTitle>
          </DialogHeader>
          <PostCreateForm
            initialData={initialData}
            onClose={onClose}
            onSuccess={onSuccess}
          />
        </DialogContent>
      </Dialog>
    )
  }

  // If used as a standalone component (less common for Dialogs, but handling for compatibility)
  return (
    <PostCreateForm
      initialData={initialData}
      onClose={onClose}
      onSuccess={onSuccess}
    />
  )
}

